export const PATHS = {
  SW_MT: '/home/orangepi/sw-mt',
  SW_MT_STABLE: '/home/orangepi/sw-mt-stable',
  PYTHON: '/home/orangepi/venv/bin/python',
};

export const GIT_REMOTE = 'https://mserverv2.motomco.com.br/sw-mt.git';

export const PM2_PROCESSES = [
  'init_main',
  'init_loader',
  'init_extern_update',
  'init_watcher',
];

export const BRANCH_PATTERN = 'origin/SW.MT.*';

/** sort -V — compatível com /bin/sh (dash); não usar $((10#$n)) */
const LATEST_BRANCH_CMD = `git branch -r 2>/dev/null | sed 's|^[[:space:]]*||' | grep '^origin/SW.MT\\.' | sed 's|origin/||' | sort -V | tail -1`;

export const STEP_TIMEOUT_MS = 120000;

/** Passo 1 inclui git fetch — equipamentos lentos podem passar de 2 min */
export const STEP_TIMEOUT_BY_ID = {
  1: 300000,
  2: 120000,
  3: 180000,
  4: 180000,
  5: 600000,
  6: 60000,
  7: 120000,
  9: 120000,
};

export const getStepTimeoutMs = (stepId) => STEP_TIMEOUT_BY_ID[stepId] ?? STEP_TIMEOUT_MS;

const GIT_FETCH = 'GIT_TERMINAL_PROMPT=0 GIT_ASKPASS=/bin/false git fetch --prune 2>&1';

const STEP_1_COMMAND = `echo "=== PASSO 1 ==="; cd /home/orangepi/sw-mt || exit 0; git remote set-url origin ${GIT_REMOTE} 2>&1; git remote -v 2>&1; echo "Versao: $(git branch --show-current 2>&1)"; echo "Lock:"; ls -la .git/index.lock 2>&1; echo "Iniciando fetch..."; ${GIT_FETCH}; echo "fetch exit: $?"; git branch -r 2>&1 | grep "SW.MT.00.02" | tail -5; LATEST=$(${LATEST_BRANCH_CMD}); echo "Ultima versao: $LATEST"; exit 0`;

const STEP_2_COMMAND = `echo "=== PASSO 2 ==="; pm2 stop init_extern_update 2>&1; sleep 5; if [ -d /home/orangepi/sw-mt-stable/.git ]; then cd /home/orangepi/sw-mt-stable && git remote set-url origin ${GIT_REMOTE} 2>&1 && git remote -v 2>&1; fi; cd /home/orangepi/sw-mt || exit 0; git remote set-url origin ${GIT_REMOTE} 2>&1; git remote -v 2>&1; ls -la .git/index.lock 2>&1; unlink .git/index.lock 2>/dev/null; mv .git/index.lock .git/index.lock.bak 2>/dev/null; ls -la .git/index.lock 2>&1 || echo "[OK] sem index.lock"; if [ -d /home/orangepi/sw-mt-stable/.git ]; then unlink /home/orangepi/sw-mt-stable/.git/index.lock 2>/dev/null; mv /home/orangepi/sw-mt-stable/.git/index.lock /home/orangepi/sw-mt-stable/.git/index.lock.bak 2>/dev/null; fi; exit 0`;

const STEP_3_COMMAND = `echo "=== PASSO 3 ==="; cd /home/orangepi/sw-mt || exit 0; unlink .git/index.lock 2>/dev/null; ${GIT_FETCH}; git reset --hard 2>&1; echo "reset exit: $?"; git clean -fd 2>&1; echo "[OK] reset/clean"; exit 0`;

const STEP_4_COMMAND = `echo "=== PASSO 4 ==="; cd /home/orangepi/sw-mt || exit 0; unlink .git/index.lock 2>/dev/null; ${GIT_FETCH}; LATEST=$(${LATEST_BRANCH_CMD}); echo "Aplicando: $LATEST"; if [ -z "$LATEST" ]; then echo "[FALHA] LATEST vazio"; exit 0; fi; git checkout -B "$LATEST" "origin/$LATEST" 2>&1; echo "checkout exit: $?"; git reset --hard "$LATEST" 2>&1; git branch --show-current 2>&1 | grep -q "$LATEST" && echo "[OK] sw-mt atualizado" || echo "[FALHA] veja acima"; exit 0`;

const STEP_5_COMMAND = `echo "=== PASSO 5 ==="; if [ ! -d /home/orangepi/sw-mt-stable/.git ]; then echo "[OK] stable nao existe, pulando"; exit 0; fi; cd /home/orangepi/sw-mt-stable || exit 0; git remote set-url origin ${GIT_REMOTE} 2>&1; unlink .git/index.lock 2>/dev/null; ${GIT_FETCH}; VER=$(git -C /home/orangepi/sw-mt branch --show-current 2>&1); echo "Sincronizando para: $VER"; git checkout -B "$VER" "origin/$VER" 2>&1; git reset --hard "$VER" 2>&1; git clean -fd 2>&1; rsync -a --delete /home/orangepi/sw-mt/ /home/orangepi/sw-mt-stable/ 2>&1; git branch --show-current 2>&1 | grep -q "$VER" && echo "[OK] stable" || echo "[FALHA] stable"; exit 0`;

const STEP_6_COMMAND = `echo "=== PASSO 6 ==="; pm2 restart init_main init_loader init_extern_update init_watcher 2>&1; pm2 save 2>&1; echo "[OK] pm2 restart enviado (ignore comando: erro se o app subir)"; exit 0`;

export const PM2_RESTART_WAIT_MS = 15000;

const STEP_7_COMMAND = `echo "=== PASSO 7: LIMPAR CURVAS ==="; /home/orangepi/venv/bin/python -c "from db import getInstance as DB; DB().clear_charts('CUSTOM'); DB().clear_charts('COMPLEMENT'); DB().clear_charts('INMETRO'); DB().conn.commit(); print('[OK] Curvas limpas')" 2>&1; echo "INSTRUCAO: Abrir menu Atualizar no equipamento para baixar curvas"; exit 0`;

const STEP_8_COMMAND = `echo "=== PASSO 8: REBOOT ==="; echo "Reiniciando em 5 segundos..."; sleep 5; reboot`;

const STEP_9_COMMAND = `echo "=== PASSO 9: CONFIRMACAO ==="; echo "=== CHECK ==="; cd /home/orangepi/sw-mt; echo "Dir: $(pwd)"; echo "Versao sw-mt: $(git branch --show-current 2>&1)"; echo "Versao sw-mt-stable: $(git -C /home/orangepi/sw-mt-stable branch --show-current 2>&1)"; ls -la .git/index.lock 2>&1; pm2 list 2>&1; exit 0`;

export const CORE_UPDATE_STEPS = [
  { id: 1, title: 'Diagnóstico (remote, versão, fetch, última branch)', command: STEP_1_COMMAND, abortOnFailure: true, timeoutMs: STEP_TIMEOUT_BY_ID[1] },
  { id: 2, title: 'Parar update automático, remote e remover index.lock', command: STEP_2_COMMAND, abortOnFailure: true, timeoutMs: STEP_TIMEOUT_BY_ID[2] },
  { id: 3, title: 'Reset hard + clean (working tree)', command: STEP_3_COMMAND, abortOnFailure: true, timeoutMs: STEP_TIMEOUT_BY_ID[3] },
  { id: 4, title: 'Checkout na última versão (sw-mt)', command: STEP_4_COMMAND, abortOnFailure: true, timeoutMs: STEP_TIMEOUT_BY_ID[4] },
  { id: 5, title: 'Sincronizar sw-mt-stable + rsync', command: STEP_5_COMMAND, abortOnFailure: false, timeoutMs: STEP_TIMEOUT_BY_ID[5] },
  { id: 6, title: 'Reiniciar serviços PM2', command: STEP_6_COMMAND, abortOnFailure: false, timeoutMs: STEP_TIMEOUT_BY_ID[6] },
];

export const OPTIONAL_CLEAR_CURVES_STEP = {
  id: 7,
  title: 'Limpar curvas para redownload',
  command: STEP_7_COMMAND,
  abortOnFailure: false,
  timeoutMs: STEP_TIMEOUT_BY_ID[7],
};

export const OPTIONAL_REBOOT_STEP = {
  id: 8,
  title: 'Reboot do equipamento',
  command: STEP_8_COMMAND,
  abortOnFailure: false,
  expectDisconnect: true,
  timeoutMs: null,
};

export const POST_REBOOT_STEP = {
  id: 9,
  title: 'Confirmar versão instalada',
  command: STEP_9_COMMAND,
  abortOnFailure: false,
  timeoutMs: STEP_TIMEOUT_BY_ID[9],
};

export const buildEquipmentUpdateSteps = ({ includeClearCurves = false, includeReboot = false } = {}) => {
  const steps = [...CORE_UPDATE_STEPS];
  if (includeClearCurves) steps.push(OPTIONAL_CLEAR_CURVES_STEP);
  if (includeReboot) steps.push(OPTIONAL_REBOOT_STEP);
  return steps;
};
